export const SUMMARY = "Summary";
export const VACCINATION = "Vaccination Percentage";
export const DAILY_CONFIRMED = "Daily Cases";
export const DAILY_DEATHS = "Daily Deaths";
export const TOTAL_CONFIRMED = "Total Cases";
export const TOTAL_DEATHS = "Total Deaths";
export const COUNTRY = "Countries Info";
